import { Participant } from '@seen/core/models/patients/participant'
import { type JSX, useState } from 'react'
import { ComboboxButton } from '#src/components/ComboboxButton.tsx'
import { RichTextEditor } from '#src/components/rich-text-editor/RichTextEditor.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

// A scratch note for trying observations the way a clinician meets them:
// type @ and pick one. Answers are recorded for the demo participant chosen;
// the note itself is not saved.
export function NotePlayground(): JSX.Element {
  const participants = useSearch(Participant, Participant.demoOnlySearchQuery())
  const [participantId, setParticipantId] = useState('')
  const participant = (participants.data ?? []).find(
    (candidate) => candidate.id === participantId
  )

  return (
    <section className="flex flex-col gap-3" aria-label="Test note">
      <div className="flex max-w-md min-w-64 flex-col gap-1 text-sm">
        <span>Demo participant</span>
        <ComboboxButton
          className="w-full justify-start"
          value={participantId}
          onChange={setParticipantId}
          placeholder="Choose one to record against"
          options={(participants.data ?? []).flatMap((candidate) =>
            candidate.id ? [{ value: candidate.id, label: candidate.name }] : []
          )}
        />
      </div>
      <div className="rounded-md border">
        <RichTextEditor
          key={`playground-${participantId}`}
          aria-label="Test note"
          defaultValue=""
          participant={participant}
          placeholder="Write a note, then type @ to record an observation…"
        />
      </div>
    </section>
  )
}
